module.exports = __webpack_public_path__ + "img/time-not-covered.d9b0d898.svg";